<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import URL from '@/views/mis/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  let status = {0:"失败",1:"成功"};
  let type = {0:"真实",1:"模拟转真实"};
  let target = {p1:"p1",p2:"p2",p3:"p3",p4:"p4"};
  let creditTunnel2 = {WANGSHANG:"WANGSHANG",XIUPAI:"XIUPAI",XUNCHENG:"XUNCHENG",JUHE:"JUHE"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('mis.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if( window.$t('mis.bt.down') == clickName){
            //隐藏关键字段
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
            download.exportExcel(URL.registervalidate.export,param,"开户验证记录");
        }else if(window.$t('mis.bt.export') == clickName){
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
            download.exportExcel(URL.registervalidate.export,param,"开户验证记录");
        }
      },
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('mis.common.startTime'), field: 'startTime',type:5},
              { title: window.$t('mis.common.endTime'), field: 'endTime',type:5},
              { title: window.$t('mis.registervalidate.customerNo'), field: 'customerNo'},
              { title: window.$t('mis.common.phone'), field: 'mobilePhone'},
              { title: window.$t('mis.common.name'), field: 'chineseName'},
              { title: window.$t('mis.registervalidate.registerType'), field: 'registerType',type:2,optionList:type},
              { title: window.$t('mis.registervalidate.target'), field: 'target',type:2,optionList:target},
              { title: window.$t('mis.registervalidate.creditTunnel2'), field: 'creditTunnel2',type:2,optionList:creditTunnel2},
              { title: window.$t('mis.registervalidate.validateStatus2'), field: 'validateStatus2',type:2,optionList:status},
              { title: window.$t('mis.registervalidate.validateStatus3'), field: 'validateStatus3',type:2,optionList:status},
              { title: window.$t('mis.registervalidate.registerStatus'), field: 'registerStatus',type:2,optionList:status},
              {click: window.$t('mis.bt.search')},
              {click: window.$t('mis.bt.down')},
              {click: window.$t('mis.bt.export')},

          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.registervalidate.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('mis.registervalidate.customerNo'), field: 'customerNo'},
              { title: window.$t('mis.common.phone'), field: 'mobilePhone'},
              { title: window.$t('mis.common.name'), field: 'chineseName'},
              { title: window.$t('mis.common.idNumber'), field: 'idNumber'},
              { title: window.$t('mis.registervalidate.channel'), field: 'channel'},
              { title: window.$t('mis.registervalidate.creditTunnel2'), field: 'creditTunnel2'},
              { title: window.$t('mis.registervalidate.creditTunnel3'), field: 'creditTunnel3'},
              { title: window.$t('mis.registervalidate.validateStatus2'), field: 'validateStatus2',render:(data,full)=>{
                      return status[data] || "";
                  }},
              { title: window.$t('mis.registervalidate.validateStatus3'), field: 'validateStatus3',render:(data,full)=>{
                      return status[data] || "";
                  }},
              { title: window.$t('mis.registervalidate.target'), field: 'target'},
              { title: window.$t('mis.registervalidate.registerStatus'), field: 'registerStatus'},
              { title: window.$t('mis.registervalidate.registerType'), field: 'registerType',render:(data,full)=>{
                      return type[data] || "";
                  }},
              { title: window.$t('mis.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('mis.common.remark'), field: 'remark'},
              { title: window.$t('mis.registervalidate.kycResult'), field: 'kycResult'},
              { title: window.$t('mis.registervalidate.personMarkTunnel'), field: 'personMarkTunnel'},
              { title: window.$t('mis.registervalidate.personMarkResult'), field: 'personMarkResult'},
              { title: window.$t('mis.registervalidate.creditLoanTunnel'), field: 'creditLoanTunnel'},
              { title: window.$t('mis.registervalidate.creditLoanResult'), field: 'creditLoanResult'},
          ]
        }
      }
    }
  }
</script>
